import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Home, Phone, Search, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { COMPANY_INFO } from '../mock';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Seite nicht gefunden | Dein Gutachten Direkt</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <div className="mb-8">
            <span className="text-8xl font-bold text-brand-green">404</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Seite nicht gefunden
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Die angeforderte Seite existiert leider nicht oder wurde verschoben.
          </p>
          
          <div className="grid sm:grid-cols-2 gap-4 mb-12">
            <Link to="/">
              <Button className="w-full bg-brand-green hover:bg-brand-green-dark text-white py-6 text-lg">
                <Home className="w-5 h-5 mr-2" />
                Zur Startseite
              </Button>
            </Link>
            <a href={`tel:${COMPANY_INFO.phone}`}>
              <Button variant="outline" className="w-full border-2 border-gray-300 py-6 text-lg">
                <Phone className="w-5 h-5 mr-2" />
                Anrufen
              </Button>
            </a>
          </div>
          
          <div className="bg-gray-50 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Das könnte Sie interessieren:</h2>
            <div className="grid gap-3">
              <Link to="/unfallgutachten" className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:border-brand-green transition-colors">
                <Search className="w-5 h-5 text-brand-green" />
                <span className="text-gray-700">Unfallgutachten beauftragen</span>
              </Link>
              <Link to="/ratgeber/nach-unfall-checkliste" className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:border-brand-green transition-colors">
                <Search className="w-5 h-5 text-brand-green" />
                <span className="text-gray-700">Checkliste nach dem Unfall</span>
              </Link>
              <Link to="/kontakt" className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:border-brand-green transition-colors">
                <Search className="w-5 h-5 text-brand-green" />
                <span className="text-gray-700">Kontakt aufnehmen</span>
              </Link>
              <Link to="/bewertungen" className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:border-brand-green transition-colors">
                <Search className="w-5 h-5 text-brand-green" />
                <span className="text-gray-700">Kundenbewertungen</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
